var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{attrs:{"id":_vm.pickIndex + 'shaftRow',"width":"5","height":"5"},on:{"click":_vm.handleCanvasClick}})}
var staticRenderFns = []

export { render, staticRenderFns }